import { CommonModule } from '@angular/common';
import { Component, Inject, NgModule } from '@angular/core';
import { MatSnackBarModule, MAT_SNACK_BAR_DATA, MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

export interface ToastConfig {
  message: string;
  icon: string;
}

@Component({
    selector: 'ts-toast-message',
    templateUrl: './toast-message.component.html',
    styleUrls: ['./toast-message.component.scss'],
    standalone: false
})
export class ToastMessageComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public readonly data: ToastConfig,
  ) { }
}

@NgModule({
  imports: [CommonModule, MatSnackBarModule, TranslateModule],
  declarations: [ToastMessageComponent],
  exports: [ToastMessageComponent],
  providers: [
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 1000 } }
  ]
})
export class ToastMessageComponentModule { }
